// Import any necessary dependencies
import { put, call, takeLatest, all, select } from "redux-saga/effects";
import {
  getUserSuccess,
  getUserFailure,
  updateAnyState,
} from "../actions/userActions";
import { BASE_BACKEND_URL } from "../constant";
import { toast } from "react-toastify";
import fetchApiHelper from "./fetchAPIHelper";



function* getUserWorker(action) {

  try {
    const response = yield call(
      fetchApiHelper,
      `${BASE_BACKEND_URL}/api/user/get_user`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        method: "GET",
      }
    );
    if (response.status === 200) {
      yield put({
        type: "UPDATE_ANY_USER_STATE",
        payload: {
          loading: false,
          loggedin: true,
          username: response.body.username,
          first_name: response.body.first_name,
          last_name: response.body.last_name,
          email: response.body.email,
          id: response.body.id,
          groups: response.body.groups,
        },
      });
    } else if (response.status === 401) {
      // toast.error("Invalid Credentials", {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });

      if (localStorage.getItem("future_employer_token")) {
        yield put({
          type: "GET_FUTURE_EMPLOYER",
          payload: { token: localStorage.getItem("future_employer_token") },
        });
      } else {
        yield put({
          type: "UPDATE_ANY_USER_STATE",
          payload: {
            loading: false,
            loggedin: false,
          },
        });
      }
    } else if (response.status === 400) {
      // toast.error("Invalid Credentials", {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
      if (localStorage.getItem("future_employer_token")) {
        yield put({
          type: "GET_FUTURE_EMPLOYER",
          payload: { token: localStorage.getItem("future_employer_token") },
        });
      } else {
        yield put({
          type: "UPDATE_ANY_USER_STATE",
          payload: { loading: false },
        });
      }
    } else {
      toast.error("Can't able to Signin, Please try after some time", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      yield put({
        type: "UPDATE_ANY_USER_STATE",
        payload: { loading: false },
      });
    }
  } catch (err) {
    // toast.error("Error occured while signing up", {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
    console.log("Error occured while signing up");
    yield put({
      type: "UPDATE_ANY_USER_STATE",
      payload: { loading: false },
    });
  }
}

function* getUserWatcher() {
  yield takeLatest("GET_USER", getUserWorker);
}
export default getUserWatcher;
